import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { Space, Input, Button, message } from 'antd';
import * as translations from '../strings';
import { getLangKey } from 'appJS/models/Language';
import { SquareCheckBig } from 'lucide-react';
import cx from 'classnames';
import track from 'appJS/utils/analytics';

const strings = translations[getLangKey()];
const BUGHERD_WORDPRESS_PLUGIN_URL = 'https://wordpress.org/plugins/bugherd/';

export const WordpressContent = ({
  apiKey,
  onInstallCallback,
  isOnboarding
}: {
  apiKey: string;
  onInstallCallback: () => void;
  isOnboarding: boolean;
}) => {
  const [installed, setInstalled] = useState<boolean>(false);

  const handleTracking = (eventName: string) => {
    track(eventName, {
      from: isOnboarding ? 'onboarding' : 'settings'
    });
  };

  useEffect(() => {
    if (installed) onInstallCallback();
  }, [installed]);

  return (
    <div className={styles.wordpressContainer}>
      <ul className={styles.instructionList}>
        <li className={styles.instructionItem}>
          <strong className={styles.instructionNumber}>1. </strong>
          <span className={styles.instructionText}>{strings.downloadThe}</span>
          <Button
            type="link"
            className={styles.downloadButton}
            href={BUGHERD_WORDPRESS_PLUGIN_URL}
            target="_blank"
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              handleTracking('Clicked wordpress plugin link');
              window.open(BUGHERD_WORDPRESS_PLUGIN_URL, '_blank');
            }}
          >
            {strings.bugherdWordpressPlugin}
          </Button>
        </li>
        <li className={styles.instructionItem}>
          <strong className={styles.instructionNumber}>2. </strong>
          <span className={styles.instructionText}>
            {strings.activatePlugin}
          </span>
        </li>
      </ul>
      <Space.Compact className={styles.copyInputContainer}>
        <Input
          type="text"
          className={styles.instructionInput}
          readOnly
          value={apiKey}
        />
        <Button
          type="primary"
          className={styles.inputCopyButton}
          onClick={() => {
            navigator.clipboard.writeText(apiKey);
            message.success(strings.copiedToClipboard());
          }}
        >
          {strings.copy}
        </Button>
      </Space.Compact>
      <Button
        type="primary"
        onClick={() => {
          handleTracking('Clicked wordpress installed button');
          setInstalled(true);
        }}
        className={cx(styles.actionButton, {
          [styles.overridden]: installed
        })}
        title="Click here to continue if you have installed the WordPress Plugin"
        icon={
          installed ? (
            <SquareCheckBig className={styles.checkIcon} />
          ) : (
            undefined
          )
        }
      >
        {installed ? strings.updating : strings.doneThis}
      </Button>
    </div>
  );
};
